class ResetPassword {
    constructor(container) {
        this.container = container;
        this.resetPasswordForm = container.querySelector('#recover-password')
        this.loginForm = container.querySelector('#customer')
        this.showToggle = container.querySelector("[data-recover-password-show]")
        this.hideToggle = container.querySelector("[data-recover-password-hide]")
        this.init();
    }

    init() {
        this.handlePasswordRecoveryForm();
    }

    handlePasswordRecoveryForm() {
        this.showToggle.addEventListener("click", (e) => {
            e.preventDefault();
            this.showRecoverPasswordForm()
        })
        this.hideToggle.addEventListener("click", (e) => {
            e.preventDefault();
            this.hideRecoverPasswordForm()
        })
        if (window.location.href.includes('#recover')) { this.showRecoverPasswordForm() }
    }

    showRecoverPasswordForm() {
        this.resetPasswordForm.style.display = 'flex';
        this.loginForm.style.display='none';
    }

    hideRecoverPasswordForm() {
        this.resetPasswordForm.style.display = 'none';
        this.loginForm.style.display = 'flex';
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new ResetPassword (
      document.querySelector('[data-login-container]')
    )
})